import { IconButton, Tooltip } from '@salecycle/ui-component-library';
import { useFlags, usePermissions } from 'core/app/AppContext';
import { Permission } from 'entities/user';
import React from 'react';

interface IProps {
  permissions: Permission[];
  featureFlags?: string[];
  tooltipDescription: string;
  onClick: (event: React.MouseEvent<Element, MouseEvent>) => void;
  icon: string;
  ariaLabel: string;
}

export const AuthorisedClientListButton: React.FC<IProps> = (props: IProps) => {
  const { hasPermissionsAll } = usePermissions();
  const { hasFlags } = useFlags();
  return hasPermissionsAll(props.permissions) && hasFlags(props.featureFlags) ? (
    <Tooltip title={props.tooltipDescription}>
      <IconButton icon={props.icon} onClick={props.onClick} ariaLabel={props.ariaLabel} />
    </Tooltip>
  ) : null;
};
